import styled from "styled-components"
import Button from "../Button"
import { device } from "../../themes/device"

const ButtonIcon = styled(Button)`
  cursor: pointer;
  outline: none;
  border: none;
  height: 40px;
  width: 40px;
  display: block;
  padding: 0;
  margin: 0 32px 0 auto;
  ${props => props.marginBottom && `margin-bottom: ${props.marginBottom}`}
  background: ${props =>
    props.background ? `url(${props.background})` : "none"};

background-repeat: no-repeat;

  @media ${device.laptop} {
    margin: 0 32px 0 auto;
  }

  @media ${device.laptopL} {
    margin: 0 32px 0 auto;
  }
`

export default ButtonIcon
